<template>
  <div class="filter-container">
    <el-input class="filter-item" style="width: 180px" clearable placeholder="客户名称或手机号"
      v-model="listQuery.key"></el-input>
    <el-input class="filter-item" style="width: 180px" clearable placeholder="主订单号"
      v-model="listQuery.bigOrderNo"></el-input>
    <el-date-picker v-model="listQuery.dateRange1" type="daterange" range-separator="至" start-placeholder="订单创建日期"
      end-placeholder="订单结束日期" value-format="yyyy-MM-dd">
    </el-date-picker>
    <el-cascader class="filter-item" style="width: 350px" clearable placeholder="选择经销商" filterable change-on-select
      :show-all-levels="false" :options="dealerOptions" v-model="listQuery.dealerCode">
    </el-cascader>
    <el-select class="filter-item" style="width: 180px" clearable placeholder="选择客户来源"
      @clear="listQuery.fromType = null" v-model="listQuery.fromType">
      <el-option v-for="item in clueTypeList" :key="item.value" :label="item.name" :value="item.value"> </el-option>
    </el-select>
    <el-select style="width: 150px" class="filter-item" multiple v-model="listQuery.onlineSource"
      v-if="listQuery.fromType === 1" placeholder="选择线上来源">
      <el-option v-for="item in importSources" :key="item.dataName" :label="item.dataDisplay" :value="item.dataName">
      </el-option>
    </el-select>

    <el-select style="width: 150px" class="filter-item" multiple v-model="listQuery.fromSources"
      v-if="listQuery.fromType === 2" placeholder="选择线下来源">
      <el-option v-for="item in customerFromSources" :key="item.dataValue" :label="item.dataDisplay"
        :value="item.dataValue">
      </el-option>
    </el-select>
    <el-select class="filter-item" style="width: 180px" clearable v-model="listQuery.orderType" placeholder="选择业务类型">
      <el-option v-for="item in orderBusinessType" :key="item.dataValue" :value="item.dataValue"
        :label="item.dataDisplay">
      </el-option>
    </el-select>
    <el-select class="filter-item" style="width: 180px" clearable v-model="listQuery.orderStatus" placeholder="选择订单状态"
      multiple>
      <el-option v-for="item in mainOrderStatusDics" :key="item.dataValue" :label="item.dataDisplay"
        :value="String(item.dataValue)"></el-option>
    </el-select>

    <el-cascader class="filter-item" style="width: 180px;" placeholder="选择订购车型" filterable collapse-tags
      :props="{ multiple: true }" clearable :show-all-levels="true" :options="carOptions" v-model="listQuery.specIds">
    </el-cascader>

    <el-date-picker v-model="listQuery.dateRange2" type="daterange" range-separator="至" start-placeholder="订单审核开始日期"
      end-placeholder="订单审核结束日期" value-format="yyyy-MM-dd">
    </el-date-picker>

    <el-date-picker v-model="listQuery.dateRange3" type="daterange" range-separator="至" start-placeholder="实际交车开始日期"
      end-placeholder="实际交车结束日期" value-format="yyyy-MM-dd">
    </el-date-picker>

    <el-input class="filter-item" style="width: 180px;" v-model.number="listQuery.customerId" placeholder="客户ID" clearable></el-input>
    <el-input class="filter-item" style="width: 180px;" v-model.number="listQuery.clueId" placeholder="线索ID" clearable></el-input>

    <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
    <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
    <el-button class="filter-item" icon="el-icon-download" @click="doExport">导出</el-button>
  </div>
</template>

<script>
import { clueTypeList } from '../js/form-options'

export default {
  props: {
    listQuery: {
      type: Object,
      required: true,
      default: () => { }
    },
    importSources: {
      type: Array,
      required: true,
      default: () => []
    },
    customerFromSources: {
      type: Array,
      required: true,
      default: () => []
    },
    dealerOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    mainOrderStatusDics: {
      type: Array,
      required: true,
      default: () => []
    },
    orderBusinessType: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      clueTypeList: Object.freeze(clueTypeList),
      carOptions: [], // 意向车系
    }
  },
  mounted() {
    this.retrieveCarOptions();
  },
  methods: {
    // 车型数据
    retrieveCarOptions() {
      this.$httpAuth
        .post("/v1/backendVehicleRpc/OpeVehicleJsonTree")
        .then((response) => {
          this.carOptions = response.data.data;
        });
    },
    doExport() {
      this.$emit("do-export")
    },
    doSearch() {
      this.$emit("do-search")
    },
    doReset() {
      this.$emit("do-reset")
    },
  }
}
</script>
<style lang="scss" scoped></style>